import APICaller from './APICaller.js';
import settings from './settings.js';

const api = new APICaller(settings.connections.apiURL);




const apiCalls = {
    internalApi: api,
    organization: {
        getSingle: function()
        {
            return api.Get(["organization"]);
        },
        // post: function(organizationData)
        // {
        //     return api.Post(["organization"], organizationData);
        // },
        // logo:
        // {
        //     post: function(formData)
        //     {
        //         return api.PostForm(["organization", "logo"], formData);
        //     },
        //     downloadUrl: function()
        //     {
        //         return api.GetApiURL(["organization","logo"]);
        //     },
        //     delete: function()
        //     {
        //         return api.Delete(["organization", "logo"]);
        //     }
        // }
    },
    authentication: {
        postLogin: function(requestBody)
        {
            return api.Login(["auth", "login"], requestBody);
        },
        getLoginOrganizations: function()
        {
            return api.Get(["auth", "login", "organizations"]);
        }
        ,
        changeLoginOrganization: function(organizationID)
        {
            return api.Get(["auth", "login", "organizations", organizationID])
            .then(async (response) =>
            {
                if(response.ok)
                {
                    api.token = await response.text();
                    return true;
                }
                else return false;
            });
        },
        postPasswordChange: function(data)
        {
            return api.Post(["auth","password","change"], data);
        },
        postPasswordReset: function(data)
        {
            return api.Post(["auth","password","reset"], data);
        }
    },
    users: {
        getAll: function(userIDs, disabled = undefined)
        {
            let queryParams = {};
            if(Array.isArray(userIDs))
            {
                //queryParams.userID = userIDs.join();
                queryParams.userID = userIDs;
            }
            else if (typeof(userIDs) === "string")
            {
                queryParams.userID = userIDs;
            }
            if(disabled !== undefined)
            {
                queryParams.disabled = disabled;
            }
            
            return api.Get("users",queryParams);
        },
        post: function(requestBody)
        {
            return api.Post("users",requestBody);
        },
        getSingle: function(userID)
        {
            return api.Get(["users", userID]);
        },
        getCurrent: function()
        {
            return api.Get(["users", "current"]);
        },
        updateSingle: function(userID, requestBody)
        {
            return api.Put(["users", userID],requestBody);
        },
        disable: function(userID)
        {
            return api.Put(["users", userID, "disabled"], true);
        },
        enable: function(userID)
        {
            return api.Put(["users", userID, "disabled"], false);
        },
        avatar:
        {
            post: function(userID, formData)
            {
                return api.PostForm(["users", userID, "avatar"], formData);
            },
            downloadUrl: function(userID)
            {
                return api.GetApiURL(["users",userID, "avatar"]);
            },
            delete: function(userID)
            {
                return api.Delete(["users", userID, "avatar"]);
            }
        }
    },
    profiles: {
        getProfileUsers: function(profile)
        {
            return api.Get(['profiles', profile, 'users']);
        },
        putProfileUsers: function(profile, usersList)
        {
            return api.Put(['profiles', profile, 'users'], usersList);
        },
        deleteProfileUsers: function(profile, userID)
        {
            return api.Delete(['profiles', profile, 'users', userID]);
        }
    },
    operations: {
        getAll: function(userProfiles)
        {
          return api.Get("operations", {profile: userProfiles});
        },
        post: function(requestBody)
        {
            return api.Post("operations", requestBody);
        },
        getSingle: function(operationID)
        {
            return api.Get(["operations", operationID]);
        },
        updateSingle: function(operationID, requestBody)
        {
            return api.Put(["operations", operationID], requestBody);
        },
        enableSingle: function (operationID)
        {
            return api.Put(["operations", operationID, "disabled"], "false");
        },
        disableSingle: function (operationID)
        {
            return api.Put(["operations", operationID, "disabled"], "true");
        },
        deleteSingle: function()
        {
            throw new Error("Not Implemented"); 
        },
        files: {
            getAll: function(operationID)
            {
                return api.Get(["operations", operationID, "files"]);
            },
            getSingle: function(operationID, fileID)
            {
                return api.Get(["operations", operationID, "files", fileID]);
            },
            fileDownloadURL : function(operationID, fileID)
            {
                return api.GetApiURL(["operations",operationID, "files", fileID, "download"]);
            },
            post: function(operationID, formData)
            {
                return api.PostForm(["operations", operationID, "files"], formData);
            },
            updateSingle: function(operationID, fileID, patchBody)
            {
                return api.Patch(["operations", operationID, "files", fileID], patchBody);
            },
            deleteSingle: function(operationID, fileID)
            {
                return api.Delete(["operations", operationID, "files", fileID]);
            },
        },
        messages: {
            getAll: function(operationID)
            {
                let queryParams = {
                    count: 999999999,
                    order: 'desc',
                    filter: ["text","call","file"]
                }
                return api.Get(["operations", operationID, "chat"], queryParams);
            },
            post: function(operationID, msgType, content)
            {
                return api.Post(["operations", operationID, "chat"], {type: msgType, content: content});
            }
        }
    },
    procedures: {

        getAll: function()
        {
            return api.Get(["procedures"]);
        },
        getSingle: function(procedureID)
        {
            return api.Get(["procedures", procedureID]);
        },
        post: function(requestBody)
        {
            return api.Post(["procedures"], requestBody);
        },
        clone: function(procedureID)
        {
            return api.Post(["procedures", procedureID, "clone"], {});
        },
        updateSingle: function(procedureID, patchBody)
        {
            return api.Put(["procedures", procedureID], patchBody);
        },
        deleteSingle: function(procedureID)
        {
            return api.Delete(["procedures", procedureID]);
        },
        files: {
            getAll: function(procedureID, abortSignal = null)
            {
                return api.Get(["procedures", procedureID, "files"], {}, abortSignal);
            },
            getSingle: function(procedureID, fileID)
            {
                return api.Get(["procedures", procedureID, "files", fileID]);
            },
            fileDownloadURL : function(procedureID, fileID)
            {                
                return api.GetApiURL(["procedures",procedureID, "files", fileID, "download"]);
            },
            post: function(procedureID, formData)
            {                
                return api.PostForm(["procedures", procedureID, "files"], formData);
            },
            updateSingle: function(procedureID, fileID, patchBody)
            {
                return api.Patch(["procedures", procedureID, "files", fileID], patchBody);
            },
            deleteSingle: function(procedureID, fileID)
            {
                return api.Delete(["procedures", procedureID, "files", fileID]);
            }
        },
        steps: {
            getAll: function(procedureID, abortSignal = null)
            {
                return api.Get(["procedures", procedureID, "steps"], {}, abortSignal);
            },
            getSingle: function(procedureID, stepID)
            {
                return api.Get(["procedures", procedureID, "steps", stepID]);
            },
            post: function(procedureID, requestBody)
            {
                return api.Post(["procedures", procedureID, "steps"], requestBody);
            },
            updateSingle: function(procedureID, stepID,  patchBody)
            {
                return api.Put(["procedures", procedureID, "steps", stepID], patchBody);
            },
            deleteSingle: function(procedureID, stepID)
            {
                return api.Delete(["procedures", procedureID, "steps", stepID]);
            },
            files: {
                getAll: function(procedureID, stepID, abortSignal = null)
                {
                    return api.Get(["procedures", procedureID, "steps", stepID, "files"], {}, abortSignal);
                },
                getSingle: function(procedureID, stepID, fileID)
                {
                    return api.Get(["procedures", procedureID, "steps", stepID, "files", fileID]);
                },
                fileDownloadURL : function(procedureID, stepID, fileID)
                {                
                    return api.GetApiURL(["procedures",procedureID, "steps", stepID, "files", fileID, "download"]);
                },
                post: function(procedureID, stepID, requestBody)
                {
                    return api.PostForm(["procedures", procedureID, "steps", stepID, "files"], requestBody);
                },
                updateSingle: function(procedureID, stepID, fileID, patchBody)
                {
                    return api.Patch(["procedures", procedureID, "steps", stepID, "files", fileID], patchBody);
                },
                deleteSingle: function(procedureID, stepID, fileID)
                {
                    return api.Delete(["procedures", procedureID, "steps", stepID, "files", fileID]);
                },
            }
        },
        templates:
        {
            getAll: function()
            {
                return api.Get(["procedures", "templates"]);
            },
            getSingle: function(templateID)
            {
                return api.Get(["procedures", "templates",  templateID]);
            },
            post: function(requestBody)
            {
                return api.Post(["procedures", "templates"], requestBody);
            },
            updateSingle: function(templateID,  patchBody)
            {
                return api.Put(["procedures", "templates",  templateID], patchBody);
            },
            deleteSingle: function(templateID)
            {
                return api.Delete(["procedures", "templates",  templateID]);
            },
            getFieldTypes: function()
            {
                return api.Get(["procedures", "templates", "fieldTypes"]);
            },
            fields:
            {
                getAll: function(templateID)
                {
                    return api.Get(["procedures", "templates", templateID, "fields"]);
                },
                getSingle: function(templateID, fieldID)
                {
                    return api.Get(["procedures", "templates", templateID, "fields", fieldID]);
                },
                post: function(templateID, requestBody)
                {
                    return api.Post(["procedures", "templates", templateID, "fields"], requestBody);
                },
                updateSingle: function(templateID, fieldID,  patchBody)
                {
                    return api.Put(["procedures", "templates", templateID, "fields", fieldID], patchBody);
                },
                deleteSingle: function(templateID, fieldID)
                {
                    return api.Delete(["procedures", "templates", templateID, "fields", fieldID]);
                }
            }
        },
        items:
        {
            getAll: function()
            {
                return api.Get(["procedures", "items"]);
            },
            getSingle: function(itemID)
            {
                return api.Get(["procedures", "items", itemID]);
            },
            post: function(requestBody)
            {
                return api.Post(["procedures", "items"], requestBody);
            },
            updateSingle: function(itemID, patchBody)
            {
                return api.Put(["procedures", "items", itemID], patchBody);
            },
            deleteSingle: function(itemID)
            {
                return api.Delete(["procedures", "items", itemID]);
            },
            categories:
            {
                getAll: function()
                {
                    return api.Get(["procedures", "items", "categories"]);
                },
                getSingle: function(categoryID)
                {
                    return api.Get(["procedures", "items", "categories", categoryID]);
                },
                post: function(requestBody)
                {
                    return api.Post(["procedures", "items", "categories"], requestBody);
                },
                updateSingle: function(categoryID, patchBody)
                {
                    return api.Put(["procedures", "items", "categories", categoryID], patchBody);
                },
                deleteSingle: function(categoryID)
                {
                    return api.Delete(["procedures", "items", "categories", categoryID]);
                },
            },
            types:
            {
                getAll: function()
                {
                    return api.Get(["procedures", "items", "types"]);
                },
                getSingle: function(typeID)
                {
                    return api.Get(["procedures", "items", "types", typeID]);
                }
            },
            icons:
            {
                getAll: function()
                {
                    return api.Get(["procedures", "items", "icons"]);
                },
                fileDownloadURL : function(iconID)
                {                
                    return api.GetApiURL(["procedures", "items", "icons", iconID]);
                },
                authDownloadURL : function(iconID)
                {                
                    return api.GetAuthenticatedURL(["procedures", "items", "icons", iconID]);
                },
            }
        },
        tasks:
        {
            getAll: function(asProfile)
            {
                return api.Get(["procedures", "tasks"], {profile: asProfile});
            },
            getSingle: function(taskID)
            {
                return api.Get(["procedures", "tasks", taskID]);
            },
            post: function(requestBody)
            {
                return api.Post(["procedures", "tasks"], requestBody);
            },
            updateSingle: function(taskID, patchBody)
            {
                return api.Put(["procedures", "tasks", taskID], patchBody);
            },
            deleteSingle: function(taskID)
            {
                return api.Delete(["procedures", "tasks", taskID]);
            },
            start: function(taskID)
            {
                return api.Post(["procedures", "tasks", taskID, "start"]);
            },
            files: {
                getAll: function(taskID)
                {
                    return api.Get(["procedures", "tasks", taskID, "files"]);
                },
                getSingle: function(taskID, fileID)
                {
                    return api.Get(["procedures", "tasks", taskID, "files", fileID]);
                },
                fileDownloadURL : function(taskID, fileID)
                {                
                    return api.GetApiURL(["procedures","tasks", taskID, "files", fileID, "download"]);
                },
                post: function(taskID, requestBody)
                {
                    return api.PostForm(["procedures", "tasks", taskID, "files"], requestBody);
                },
                updateSingle: function(taskID, fileID, patchBody)
                {
                    return api.Patch(["procedures", "tasks", taskID, "files", fileID], patchBody);
                },
                deleteSingle: function(taskID, fileID)
                {
                    return api.Delete(["procedures", "tasks", taskID, "files", fileID]);
                },
            },
            schedulers: {
                getAll: function()
                {
                    return api.Get(["procedures", "tasks", "schedulers"]);
                },
                getSingle: function(schedulerID)
                {
                    return api.Get(["procedures", "tasks", "schedulers", schedulerID]);
                },
                post: function(requestBody)
                {
                    return api.Post(["procedures", "tasks", "schedulers"], requestBody);
                },
                updateSingle: function(schedulerID, patchBody)
                {
                    return api.Put(["procedures", "tasks", "schedulers", schedulerID], patchBody);
                },
                deleteSingle: function(schedulerID)
                {
                    return api.Delete(["procedures", "tasks", "schedulers", schedulerID]);
                },
            },
            reports: {
                getAll: function(taskID)
                {
                    return api.Get(["procedures", "tasks", taskID, "reports"]);
                },
                getSingle: function(taskID, stepIndex)
                {
                    return api.Get(["procedures", "tasks", taskID, "reports", stepIndex]);
                },
                complete: function(taskID, stepIndex)
                {
                    return api.Post(["procedures", "tasks", taskID, "reports", stepIndex, "completed"]);
                },
                verifications: {
                    getAll: function(taskID, stepIndex)
                    {
                        return api.Get(["procedures", "tasks", taskID, "reports", stepIndex, "verifications"]);
                    },
                    getSingle: function(taskID, stepIndex, verificationID)
                    {
                        return api.Get(["procedures", "tasks", taskID, "reports", stepIndex, "verifications", verificationID]);
                    },
                    updateSingle: function(taskID, stepIndex, verificationID, patchBody)
                    {
                        return api.Put(["procedures", "tasks", taskID, "reports", stepIndex, "verifications", verificationID], patchBody);
                    },
                    file: {
                        post: function(taskID, stepIndex, verificationID, requestBody)
                        {
                            return api.PostForm(["procedures", "tasks", taskID, "reports", stepIndex, "verifications", verificationID, "file"], requestBody);
                        },
                        deleteSingle: function(taskID, stepIndex, verificationID)
                        {
                            return api.Delete(["procedures", "tasks", taskID, "reports", stepIndex, "verifications", verificationID, "file"]);
                        },
                        fileDownloadURL : function(taskID, stepIndex, verificationID)
                        {                
                            return api.GetApiURL(["procedures","tasks", taskID, "reports", stepIndex, "verifications", verificationID, "file"]);
                        },
                    },
                },
                timers: {
                    getAll: function(taskID, stepIndex)
                    {
                        return api.Get(["procedures", "tasks", taskID, "reports", stepIndex, "timeRecords"]);
                    },
                    getSingle: function(taskID, stepIndex, timeRecordID)
                    {
                        return api.Get(["procedures", "tasks", taskID, "reports", stepIndex, "timeRecords", timeRecordID]);
                    },
                    post: function(taskID, stepIndex, requestBody)
                    {
                        return api.Post(["procedures", "tasks", taskID, "reports", stepIndex, "timeRecords"], requestBody);
                    },
                    updateSingle: function(taskID, stepIndex, timeRecordID, patchBody)
                    {
                        return api.Put(["procedures", "tasks", taskID, "reports", stepIndex, "timeRecords", timeRecordID], patchBody);
                    },
                    deleteSingle: function(taskID, stepIndex, timeRecordID)
                    {
                        return api.Delete(["procedures", "tasks", taskID, "reports", stepIndex, "timeRecords", timeRecordID]);
                    },
                    toggle: function(taskID, stepIndex, action)
                    {
                        return api.Post(["procedures", "tasks", taskID, "reports", stepIndex, "timer"], "", {action: action});
                    },
                },
            }
        }
    },
    tags:
    {
        getAll: function()
        {
            return api.Get(["tags"]);
        },
        getSingle: function(tagID)
        {
            return api.Get(["tags", tagID]);
        },
        post: function(requestBody)
        {
            return api.Post(["tags"], requestBody);
        },
        updateSingle: function(tagID, patchBody)
        {
            return api.Put(["tags", tagID], patchBody);
        },
        deleteSingle: function(tagID)
        {
            return api.Delete(["tags", tagID]);
        },
        archive: function(tagID)
        {
            return api.Put(["tags", tagID, "disabled"], true);
        },
        restore: function(tagID)
        {
            return api.Put(["tags", tagID, "disabled"], false);
        },
    },
    AR: {
        locations: {
            getAll: function()
            {
                return api.Get(["ar", "locations"]);
            },
            getSingle: function(locationID)
            {
                return api.Get(["ar", "locations", locationID]);
            },
            post: function(requestBody)
            {
                return api.Post(["ar", "locations"], requestBody);
            },
            updateSingle: function(locationID, patchBody)
            {
                return api.Put(["ar", "locations", locationID], patchBody);
            },
            deleteSingle: function(locationID)
            {
                return api.Delete(["ar", "locations", locationID]);
            },
            picture: {
                post: function(locationID, formData)
                {
                    return api.PostForm(["ar", "locations", locationID, "picture"], formData);
                },
                downloadUrl: function(locationID)
                {
                    return api.GetApiURL(["ar", "locations",locationID, "picture"]);
                },
                delete: function(locationID)
                {
                    return api.Delete(["ar", "locations", locationID, "picture"]);
                }
            }
        }, 
        anchors: {
            getAll: function()
            {
                return api.Get(["ar", "anchors"]);
            },
            getSingle: function(anchorID)
            {
                return api.Get(["ar", "anchors", anchorID]);
            },
            post: function(requestBody)
            {
                return api.Post(["ar", "anchors"], requestBody);
            },
            updateSingle: function(anchorID, patchBody)
            {
                return api.Put(["ar", "anchors", anchorID], patchBody);
            },
            deleteSingle: function(anchorID)
            {
                return api.Delete(["ar", "anchors", anchorID]);
            },
            picture: {
                post: function(anchorID, formData)
                {
                    return api.PostForm(["ar", "anchors", anchorID, "picture"], formData);
                },
                downloadUrl: function(anchorID)
                {
                    return api.GetApiURL(["ar", "anchors",anchorID, "picture"]);
                },
                delete: function(anchorID)
                {
                    return api.Delete(["ar", "anchors", anchorID, "picture"]);
                }
            }
        }
    },
    channels: {
        getAll: function()
        {
          return api.Get("channels");
        },
        post: function(requestBody)
        {
            return api.Post("channels", requestBody);
        },
        getSingle: function(channelID)
        {
            return api.Get(["channels", channelID]);
        },
        updateSingle: function(channelID, requestBody)
        {
            return api.Put(["channels", channelID], requestBody);
        },
        enableSingle: function (channelID)
        {
            return api.Put(["channels", channelID, "disabled"], "false");
        },
        disableSingle: function (channelID)
        {
            return api.Put(["channels", channelID, "disabled"], "true");
        },
        deleteSingle: function()
        {
            throw new Error("Not Implemented"); 
        },
        files: {
            getAll: function(channelID)
            {
                return api.Get(["channels", channelID, "files"]);
            },
            getSingle: function(channelID, fileID)
            {
                return api.Get(["channels", channelID, "files", fileID]);
            },
            fileDownloadURL : function(channelID, fileID)
            {
                return api.GetApiURL(["channels",channelID, "files", fileID, "download"]);
            },
            post: function(channelID, formData)
            {
                return api.PostForm(["channels", channelID, "files"], formData);
            },
            updateSingle: function(channelID, fileID, patchBody)
            {
                return api.Patch(["channels", channelID, "files", fileID], patchBody);
            },
            deleteSingle: function(channelID, fileID)
            {
                return api.Delete(["channels", channelID, "files", fileID]);
            },
        },
        messages: {
            getAll: function(channelID)
            {
                let queryParams = {
                    count: 999999999,
                    order: 'desc',
                    filter: ["text","call","file"]
                }
                return api.Get(["channels", channelID, "chat"], queryParams);
            },
            post: function(channelID, msgType, content)
            {
                return api.Post(["channels", channelID, "chat"], {type: msgType, content: content});
            }
        }
    },
    filehosting: {
        getAll: function()
        {
            return api.Get(["filehosting"]);
        },
        getSingle: function(fileID)
        {
            return api.Get(["filehosting", fileID]);
        },
        fileDownloadURL : function(fileID)
        {
            return api.GetApiURL(["filehosting", fileID, "download"]);
        },
        publicURL : function(token)
        {
            return api.GetApiURL(["filehosting", "public", token]);
        },
        getPublicToken : function(fileID)
        {
            return api.Get(["filehosting", fileID, "publictoken"]);
        },
        post: function(formData)
        {
            return api.PostForm(["filehosting"], formData);
        },
        updateSingle: function(fileID, patchBody)
        {
            return api.Patch(["filehosting", fileID], patchBody);
        },
        deleteSingle: function(fileID)
        {
            return api.Delete(["filehosting", fileID]);
        }
    }
}
Object.freeze(apiCalls);

export default apiCalls;